import React from 'react'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import ClimeDocSF from '../../../components/superUser/account/ClimeDocSF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const ClimeDocPageUI = ({context, bucketList,
    onRefreshClick, onUpdateBucketList,
  }) =>
  <SuperUserHomePageUI context={context} className='pg_su_doc' topnav='accounts'
    headerText='Clime Finance Documents' centered={!bucketList} page='docs'
  >
    {
      !bucketList &&
      <SpinnerComponentUI />
    }
    {
      bucketList &&
      <div>
        <PageTitleUI context={context}
          titleText='Clime Finance Documents' />

        <ClimeDocSF
          context={context}
          bucketList={bucketList}
          onRefreshClick={onRefreshClick}
          onUpdateBucketList={onUpdateBucketList}
        />
      </div>
    }
  </SuperUserHomePageUI>

export default ClimeDocPageUI
